<template>
  <v-container>
    <v-row v-for="i in (endHour-startHour)" :key="i">
      <v-col v-for="x in parseInt(60/gap)" :key="x" class="pa-1">
        <v-chip
          @click="select(displayHour(i,x))"
          style="width:35px"
          :color="displayHour(i,x)==value?'orange darken-1':'grey lighten-2'"
          draggable
        >
          {{
          displayHour(i,x)
          }}
        </v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    hour: null
  }),
  props: {
    value: {
      type: String
    },
    startHour: {
      type: Number,
      default: 9
    },
    endHour: {
      type: Number,
      default: 18
    },
    gap: {
      type: Number,
      default: 15
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.hour = moment()
        .hour(this.startHour)
        .minutes(0);
    },
    displayHour(offsetHour, offsetMinute) {
      let hour = (this.hour = moment()
        .hour(this.startHour)
        .minutes(0));
      hour.add(offsetHour - 1, "h");
      hour.add((offsetMinute - 1) * this.gap, "m");
      return hour.format("HH:mm");
    },
    select(hour) {
      this.$emit("input", hour);
    }
  }
};
</script>

<style>
</style>